module.exports.name = 'pintura'
module.exports.projects = [
    {
        url: '/soluciones-tecnicas/decoracion/pinturas',
        title: 'Pinturas',
        image: () => require('./images/pinturas-3.jpg'),
        html: `
            Protección y decoración:
            Amplia gama en pinturas de exterior e interior... Transpirables lavables y ecológica
            amplia gama cromática en todas nuestras líneas de acabados.
        `,
        htmlFull: () => `
            Protección y decoración:
            Amplia gama en pinturas de exterior e interior... Transpirables lavables y ecológica
            amplia gama cromática en todas nuestras líneas de acabados:
            <ul>
                <li>Orgánicos-minerales, Acrílico Siloxánicos</li>
                <li>Minerales a base de Cal</li>
                <li>Minerales en base silicato</li>
                <li>Fondos, Esmaltes al agua, Imprégnate para madera,hidrofugantes etc...</li>
            </ul>
            Composición y propiedades de las mas desconocidas pero de cualidades exquisitas:
            <ul>
                <li>
                    Siloxanico: Las pinturas de resina de silicona (o siloxano), son sistemas de recubrimiento
                    que brindan ventajas decisivas, tanto en la primera aplicación como en obras de rehabilitación
                    o restauración.
                </li>
            </ul>
            <h3>Ventajas Pinturas Siloxánicas</h3>
            <ul>
                <li>Gran durabilidad.</li>
                <li>Repelencia a la suciedad.</li>
                <li>Repelencia al agua.</li>
                <li>Resistencia a la intemperie.</li>
                <li>Gran permeabilidad al vapor.</li>
                <li>Resistencia a la luz y colores estables.</li>
                <li>Sin disolventes (base agua).</li>
                <li>Acabado mineral.</li>
                <li>Fácil trabajabilidad (manual o mecánica).</li>
                <li>Alto poder de cubrición.</li>
                <li>Ausencia de tensiones.</li>
                <li>Alta resistencia a la abrasión.</li>
                <li>Resistencia al calor</li>
            </ul>
            <img src="${require('./images/pinturas-1.jpg')}" />
            <img src="${require('./images/pinturas-2.png')}" />
            <img src="${require('./images/pinturas-3.jpg')}" />
            <img src="${require('./images/pinturas-4.jpg')}" />
            <ul>
                <li>
                    Silicato: Las pinturas con silicato, un mineral que les otorga una gran
                    resistencia a la intemperie, lo que las hace especialmente apropiadas para
                    la cobertura de muros exteriores. 
                </li>
            </ul>
            Las pinturas de silicato se adhieren al soporte mineral a través de una reacción química
            insoluble (llamada silicificación o petrificación), y no forma película superficial.
            La transpirabilidad o permeabilidad al vapor de agua - de la pintura de silicato equivale
            a la del soporte sobre el que se aplica.
            Las superficies pintadas con pinturas de silicato se caracterizan por un pH alcalino
            que proporciona una protección natural contra la proliferación de microorganismos
            (algas, mohos, líquenes).
            <img src="${require('./images/pinturas-5.jpg')}" />
            <img src="${require('./images/pinturas-6.jpg')}" />
        `,
    },
]


// WEBPACK FOOTER //
// ./src/data/pintura.js